import { defineComponent as _defineComponent } from 'vue'
import { vModelText as _vModelText, withKeys as _withKeys, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "search" }
const _hoisted_2 = ["onKeydown"]

import { ref } from "@vue/reactivity";



export default /*#__PURE__*/_defineComponent({
  __name: 'SearchInfo',
  emits: ["submit"],
  setup(__props, { emit }) {

const name = ref("");


const submit = () => {
  if (name.value !== "") {
    emit("submit", name.value);
    name.value = "";
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("input", {
      type: "text",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((name).value = $event)),
      onKeydown: _withKeys(submit, ["enter"])
    }, null, 40, _hoisted_2), [
      [_vModelText, name.value]
    ]),
    _createElementVNode("button", { onClick: submit }, "Search")
  ]))
}
}

})